'use client'

import React, { useEffect, useRef } from 'react'
import { sendGTMEvent } from '@next/third-parties/google'

import Controls from '../Controls/Controls'
import { useUserContext } from 'src/contexts/user'
import { useWalletAuth } from 'src/hooks/useWalletAuth'
import { Button, buttonMessages } from 'components/inputs'
import TabbedBetslip from 'compositions/TabbedBetslip/TabbedBetslip'
import LiveStatistics from 'compositions/LiveStatistics/LiveStatistics'
import { ToastContainer } from '@/components/feedback/Toast/ToastContainer'

const RightSidebar: React.FC = () => {
  const { isReconnecting, isConnecting, connectOrCreateWallet } =
    useWalletAuth()
  const { isLoginComplete, isUserConnecting } = useUserContext()
  const isMounted = useRef(false)
  useEffect(() => {
    isMounted.current = true
  }, [])

  return (
    <>
      <div className="px-6 py-3 sticky top-0 z-20">
        {Boolean(isMounted.current && isLoginComplete && !isConnecting) ? (
          <Controls className="ml-auto" />
        ) : (
          <Button
            className="ml-auto"
            title={buttonMessages.connectWallet}
            size={40}
            loading={isConnecting || isReconnecting || isUserConnecting}
            onClick={() => {
              connectOrCreateWallet()
              sendGTMEvent({
                event: 'wallet_connect_initiated',
                is_betslip: false,
                section: 'header',
                login_toolkit: 'privy',
              })
            }}
          />
        )}
      </div>
      <div className="bg-bg-l0 border border-grey-10 rounded-r-md -ml-px overflow-auto wd:h-[calc(100vh_-_4.5rem)] no-scrollbar px-2 pt-1 space-y-2">
        <LiveStatistics />
        <TabbedBetslip />
      </div>
      <div className="px-2.5 py-3 sticky bottom-5 z-20 mb:hidden">
        <ToastContainer className="animate-toast-slide-in my-1" />
      </div>
    </>
  )
}

export default RightSidebar
